import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import React from "react";

import { Images } from "../../config";

import "./navHeader.css";

const NavHeader = ({ expandible, collapsed, toggle }) => {
  const location = useLocation();
  const title = ((location || {}).pathname || {}).split("/")[1];
  const LSauthName = JSON.parse(localStorage.getItem("authUser"));
  const authName = useSelector((state) => state.auth.user.name);

  return (
    <div className="nav-header-container">
      {/* <div>
        {expandible &&
          React.createElement(collapsed ? MenuOutlined : MoreOutlined, {
            className: "trigger bg-purple",
            onClick: toggle,
          })}
        <h3 className="dashboard-title">
          {title !== "" ? title : "Dashboard"}
        </h3>
      </div> */}
      <div className="site-layout-background-right">
        {/* <div className={"headerIcons"}>
          <Dropdown
            trigger={"click"}
            // overlay={<NotificationDropDown />}
            style={{ height: "65px" }}
          >
            <div>
              <img src={notificationsBell} atl="disapper" />
              </div>
          </Dropdown>
        </div> */}
        <div className="profile">
          {/* <Dropdown
            overlay={<ProfileDropDown />}
            style={{ top: "65px !important" }}
          >
            <a
              className="ant-dropdown-link"
              onClick={(e) => e.preventDefault()}
            > */}
          <img
            src={Images.DefaultAvatar}
            alt="disappear"
            style={{ width: "40px", height: "auto" }}
          />
          {/* </a>
          </Dropdown> */}
          {authName ? authName : LSauthName}
        </div>
      </div>
    </div>
  );
};
export default NavHeader;
